// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/a-major-climb.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const aMajorClimb: Score = {
  slug: "a-major-climb",
  n: 22,
  title: "A Major Climb",
  composer: "Jason Zac",
  rights: "original",
  publicSafe: true,
  key: "A",
  fifths: 3,
  time: [4, 4],
  tempo: 92,
  staves: 1,
  clefs: ["treble"],
  bars: 8,
  barQuarters: 4.0,
  lowest: 68,
  highest: 81,
  hasLyrics: false,
  jasonNote: "Three sharps this time \u2014 F sharp, C sharp and G sharp. Look at the key signature once at the start and then trust it. Same thumb-under going up, same cross-over coming down as in G Major Run.",
  teaches: ["three sharps", "A major", "thumb under going up", "crossing over coming down"],
  art: "/sight-reading/art/a-major-climb.jpg",
  artRights: "stock-free",
  background: "/sight-reading/bg/a-major-climb.jpg",
  newForThisEdition: true,
  fillsGap: "A major never appears in the printed book.",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter" },
    { bar: 1, hand: "rh", start: 1.0, dur: 1.0, midi: 73, pitch: "C#5", d: "quarter" },
    { bar: 1, hand: "rh", start: 2.0, dur: 2.0, midi: 76, pitch: "E5", d: "half" },
    { bar: 2, hand: "rh", start: 4.0, dur: 1.0, midi: 74, pitch: "D5", d: "quarter" },
    { bar: 2, hand: "rh", start: 5.0, dur: 1.0, midi: 73, pitch: "C#5", d: "quarter" },
    { bar: 2, hand: "rh", start: 6.0, dur: 2.0, midi: 71, pitch: "B4", d: "half" },
    { bar: 3, hand: "rh", start: 8.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 3, hand: "rh", start: 8.5, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 3, hand: "rh", start: 9.0, dur: 0.5, midi: 73, pitch: "C#5", d: "eighth" },
    { bar: 3, hand: "rh", start: 9.5, dur: 0.5, midi: 74, pitch: "D5", d: "eighth" },
    { bar: 3, hand: "rh", start: 10.0, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 3, hand: "rh", start: 10.5, dur: 0.5, midi: 78, pitch: "F#5", d: "eighth" },
    { bar: 3, hand: "rh", start: 11.0, dur: 0.5, midi: 80, pitch: "G#5", d: "eighth" },
    { bar: 3, hand: "rh", start: 11.5, dur: 0.5, midi: 81, pitch: "A5", d: "eighth" },
    { bar: 4, hand: "rh", start: 12.0, dur: 2.0, midi: 81, pitch: "A5", d: "half" },
    { bar: 4, hand: "rh", start: 14.0, dur: 2.0, midi: 76, pitch: "E5", d: "half" },
    { bar: 5, hand: "rh", start: 16.0, dur: 1.0, midi: 78, pitch: "F#5", d: "quarter" },
    { bar: 5, hand: "rh", start: 17.0, dur: 1.0, midi: 76, pitch: "E5", d: "quarter" },
    { bar: 5, hand: "rh", start: 18.0, dur: 2.0, midi: 74, pitch: "D5", d: "half" },
    { bar: 6, hand: "rh", start: 20.0, dur: 1.0, midi: 73, pitch: "C#5", d: "quarter" },
    { bar: 6, hand: "rh", start: 21.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 6, hand: "rh", start: 22.0, dur: 2.0, midi: 69, pitch: "A4", d: "half" },
    { bar: 7, hand: "rh", start: 24.0, dur: 0.5, midi: 76, pitch: "E5", d: "eighth" },
    { bar: 7, hand: "rh", start: 24.5, dur: 0.5, midi: 74, pitch: "D5", d: "eighth" },
    { bar: 7, hand: "rh", start: 25.0, dur: 0.5, midi: 73, pitch: "C#5", d: "eighth" },
    { bar: 7, hand: "rh", start: 25.5, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 7, hand: "rh", start: 26.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 7, hand: "rh", start: 26.5, dur: 0.5, midi: 68, pitch: "G#4", d: "eighth" },
    { bar: 7, hand: "rh", start: 27.0, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 7, hand: "rh", start: 27.5, dur: 0.5, midi: 71, pitch: "B4", d: "eighth" },
    { bar: 8, hand: "rh", start: 28.0, dur: 4.0, midi: 69, pitch: "A4", d: "whole" },
  ],
};
